import { useQuery } from "@apollo/client";
import { DeliveryFilter } from "_graphql/__generated__/globalTypes";
import { DeliveryLocations, DeliveryLocationsVariables } from "_graphql/queries/__generated__/DeliveryLocations";
// import { DeliveryFilter, DeliveryLocationsQuery, DeliveryLocationsQueryVariables } from "_graphql/queries/__generated__/graphql";
import { getDeliveryLocations } from "_graphql/queries/delivery";

const useGetDeliveryLocations = (filter?: DeliveryFilter) => {
  const { data, loading, error } = useQuery<
    DeliveryLocations,
    DeliveryLocationsVariables
  >(getDeliveryLocations, {
    variables: {
      filter,
    },
  });
  return { data, loading, error };
};

export default useGetDeliveryLocations;